export const SELECT_PACK = 'bike/SELECT_PACK';

export const ADD_ACCESSORY = 'bike/ADD_ACCESSORY';

export const REMOVE_ACCESSORY = 'bike/REMOVE_ACCESSORY';

export const SET_COLOUR = 'bike/SET_COLOUR';

export const SET_MODEL = 'bike/SET_MODEL';

export const RESET_BIKE = 'bike/RESET_BIKE';

export const RESET_ACCESSORIES = 'bike/RESET_ACCESSORIES';

export const INCREASE_ACCESSORY_QUANTITY = 'bike/INCREASE_ACCESSORY_QUANTITY';

export const DECREASE_ACCESSORY_QUANTITY = 'bike/DECREASE_ACCESSORY_QUANTITY';

export const SET_CONFLICT_CHOICE = 'bike/SET_CONFLICT_CHOICE';

export const RESOLVE_ACCESSORY_CONFLICT = 'bike/RESOLVE_ACCESSORY_CONFLICT';

export const SET_REQUIRES_SINGLE_CHOICE = 'bike/SET_REQUIRES_SINGLE_CHOICE';

export const TOGGLE_REQUIRES_ALL_CONFIRMED = 'bike/TOGGLE_REQUIRES_ALL_CONFIRMED';

export const RESOLVE_ACCESSORIES_REQUIRED = 'bike/RESOLVE_ACCESSORIES_REQUIRED';

export const CLOSE_ACCESSORY_RESOLUTION = 'bike/CLOSE_ACCESSORY_RESOLUTION';

export const REMOVE_REQUIRED_ACCESSORIES = 'bike/REMOVE_REQUIRED_ACCESSORIES';

export const REFRESH_BIKE_ACCESSORIES = 'bike/REFRESH_BIKE_ACCESSORIES';

export const RESOLVE_PACK_ACCESSORY_CONFLICT = 'bike/RESOLVE_PACK_ACCESSORY_CONFLICT';

export const RESOLVE_ACCESSORY_PACK_CONFLICT = 'bike/RESOLVE_ACCESSORY_PACK_CONFLICT';

export const REMOVE_PACK = 'bike/REMOVE_PACK';

export const LOAD_CONFIGURATION = 'bike/LOAD_CONFIGURATION';

export const SET_PREVIEWED_PACK = 'bike/SET_PREVIEWED_PACK';

export const CLEAR_PREVIEWED_PACK = 'bike/CLEAR_PREVIEWED_PACK';

export const ADD_PACK_ACCESSORY = 'bike/ADD_PACK_ACCESSORY';

export const REMOVE_PACK_ACCESSORY = 'bike/REMOVE_PACK_ACCESSORY';

export const UPDATE_PACK_ACCESSORIES = 'bike/UPDATE_PACK_ACCESSORIES';

export const CLOSE_REQUIRED_RESOLUTION = 'bike/CLOSE_REQUIRED_RESOLUTION';

export const ADD_WARRANTY_PACK = 'bike/ADD_WARRANTY_PACK';

export const REMOVE_WARRANTY_PACK = 'bike/REMOVE_WARRANTY_PACK';

export const ADD_SERVICE_PACK = 'bike/ADD_SERVICE_PACK';

export const REMOVE_SERVICE_PACK = 'bike/REMOVE_SERVICE_PACK';
